import React from "react";
import { Link } from "react-router-dom";
import "../MainPage.css";
import { Col, Row } from "react-bootstrap";

function ModuleCards(props) {
    /**
     * Generates grid of module cards containing thumbnail and description text (max of 5 lines are shown).
     * Each card is linked to their corresponding splash page.
     * @param props: training list to map over when generating the cards
     * @returns: module cards in the form of a grid (3 columns for large screens, 2 columns for medium screens, variable for smaller ones)
     */

    // Map over the filtered training list and create a module card for each one. Set column number to 3 for large viewports, 2 for medium viewports, and "auto" for smaller ones.
    return (
        <Row className="justify-content-center" lg={3} md={2} sm="auto" xs="auto">
            {props.trainingList.map(training => {
                const name = Object.keys(training)[0];

                return (
                    <Col key={name}>
                        <Link to={`/${name}`}>
                            <div className="d-inline-block py-2 px-2">
                                <div className="training-card card">
                                    <img style={{objectFit: 'cover', height: '150px'}} className="card-img-top" src={training[name]["thumbnail"]} alt={`A representation of ${training[name]["title"]}`}></img>
                                    <div className="card-body p-2">
                                        <h5 style={{maxHeight: '100px'}} className="head-sport card-title text-center">{training[name]["title"]}</h5>
                                        <p className="card-text text-white">{training[name]["text"]}</p>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </Col>
                );
            })}
        </Row>
    );
}

export default ModuleCards;